// @core/api/endpoints/chat/get_conversation_summary.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetConversationSummaryResponse,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Get conversation summary
 * Returns a compact summary of a conversation or thread optimized for agent context loading. Includes key decisions, open questions, and recent activity digest. Summary is cached and regenerated on significant activity.
 */
export async function GetConversationSummary(
  conversation_id: string,
  options?: RequestOptions
): Promise<GetConversationSummaryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/summary`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.get<GetConversationSummaryResponse>(requestPath, { ...requestOptions });
}
